import { useMemo } from "react";
import { ZoneWithCells } from "../../../types";
import { changeCurrenCellType } from "./changeCurrentCellType";
import { getDefaultState } from "./getDefaultState";
import { moveToNextCell } from "./moveToNextCell";
import { numberPressed } from "./numberPressed";
import { addColumn } from "./reducers/addColumn";
import { addRow } from "./reducers/addRow";
import { clearCells } from "./reducers/clearCells";
import { clearMouseDragPosition } from "./reducers/clearMouseDragPosition";
import { clearMousePosition } from "./reducers/clearMousePosition";
import { deleteSelectedSegments } from "./reducers/deleteSelectedSegments";
import { hideTableUI } from "./reducers/hideTableUI";
import { mergeCells } from "./reducers/mergeCells";
import { redo } from "./reducers/redo";
import { reset } from "./reducers/reset";
import { setMouseDragPosition } from "./reducers/setMouseDragPosition";
import { setMousePosition } from "./reducers/setMousePosition";
import { setWithinGutter } from "./reducers/setWithinGutter";
import { showTableUI } from "./reducers/showTableUI";
import { splitCell } from "./reducers/splitCell";
import { undo } from "./reducers/undo";
import { toggleBorderExplicitness } from "./toggleBorderExplicitness";
import { Action, State } from "./types";

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "ADD COLUMN":
      return addColumn(state, action);
    case "ADD ROW":
      return addRow(state, action);
    case "CLEAR CELLS":
      return clearCells(state, action);
    case "CLEAR MOUSE DRAG POSITION":
      return clearMouseDragPosition(state, action);
    case "CLEAR MOUSE POSITION":
      return clearMousePosition(state, action);
    case "DELETE SELECTED SEGMENTS":
      return deleteSelectedSegments(state, action);
    case "HIDE TABLE UI":
      return hideTableUI(state, action);
    case "MERGE CELLS":
      return mergeCells(state, action);
    case "REDO":
      return redo(state, action);
    case "RESET":
      return reset(state, action);
    case "SET MOUSE DRAG POSITION":
      return setMouseDragPosition(state, action);
    case "SET MOUSE POSITION":
      return setMousePosition(state, action);
    case "SET WITHIN GUTTER":
      return setWithinGutter(state, action);
    case "SHOW TABLE UI":
      return showTableUI(state, action);
    case "SPLIT CELL":
      return splitCell(state, action);
    case "UNDO":
      return undo(state, action);
    case "CHANGE CURRENT CELL TYPE" : 
      return changeCurrenCellType(state, action);
    case "TOGGLE BORDER EXPLICITNESS" :
      return toggleBorderExplicitness(state, action);
    case "NUMBER PRESSED" : 
      return numberPressed(state, action);
    case "MOVE TO NEXT CELL" :
      return moveToNextCell(state, action);
  }
};

export const useDefaultState = (zone: ZoneWithCells): State =>
  useMemo(() => getDefaultState(zone), [zone]);
